import './index.less';

import * as React from 'react';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Menu } from 'antd';
import { L, isGranted } from '../../lib/abpUtility';

import { appRouters, MSPRoute } from '../../components/Router/router.config';
import { ItemType } from 'antd/lib/menu/hooks/useItems';
import AbbIcon from '../../packages/AbbIcon';
import { ListPriceType } from '../../services/serviceProxy';

class SiderMenu extends React.Component<RouteComponentProps> {

  //是否存在子菜单
  hasAnyMenuNodes = (appRouters: MSPRoute[]): boolean => {
    return (
      appRouters
        //非布局页且显示菜单
        .some(
          (item) =>
            !item.isLayout &&
            item.showInMenu &&
            //无权限 或 有授权权限
            (!item.permission || isGranted(item.permission))
        )
    );
  };

  componentDidMount() {
    // 隐藏数据维护,独立显示技术协议
    if (isGranted('Pages.SmartConfigurator.Maintenance.Techinal.Menu')) {
      const maintenance = appRouters.splice(7, 1);
      if (maintenance[0] && maintenance[0].children && maintenance[0].children.length > 1) {
        appRouters.splice(7, 0, maintenance[0].children[1]);
      }
    }
  }

  /** 收集侧栏/顶栏中可点击的菜单 path（与 getMenuNodes 过滤规则一致） */
  collectMenuPaths = (routes: MSPRoute[]): string[] => {
    const isMsp = abp.utils.getCookieValue('Abp.Login.UserType') == 'MSP';
    const paths: string[] = [];

    routes.forEach((route) => {
      if (route.isLayout || !route.showInMenu) return;
      if (isMsp && route.path.startsWith('/IworldDetial')) return;
      if (
        !isMsp &&
        !(
          route.path.startsWith('/IworldDetial') ||
          route.path.startsWith('/IWorldDashboard') ||
          route.path.startsWith('/dashboard')
        )
      ) {
        return;
      }
      if (route.permission && !isGranted(route.permission)) return;

      if (route.children?.length) {
        paths.push(...this.collectMenuPaths(route.children));
      } else {
        paths.push(route.path);
      }
    });

    return paths;
  };

  /** 子路由（如系列页）高亮对应的一级菜单项 */
  getSelectedMenuKey = (): string => {
    const { pathname, search } = this.props.location;
    const params = new URLSearchParams(search);
    const listPriceType = params.get('listPriceType');

    if (
      pathname.startsWith('/listPrice/standard') &&
      listPriceType != null &&
      Number(listPriceType) === ListPriceType.CustomerCode
    ) {
      return '/listPrice/customer';
    }

    const menuPaths = this.collectMenuPaths(appRouters);
    const matched = menuPaths
      .filter((p) => pathname === p || pathname.startsWith(`${p}/`))
      .sort((a, b) => b.length - a.length)[0];

    return matched ?? pathname;
  };

  getMenuNodes = (appRouters: MSPRoute[]): ItemType[] => {
    // return (
    //   appRouters
    //     //非布局且显示菜单
    //     .filter((item) => !item.isLayout && item.showInMenu)
    //     .map((route) => {
    //       //无权限返回null
    //       if (route.permission && !isGranted(route.permission)) return null;
    //       //无子菜单
    //       if (!route.children) {
    //         return (
    //           {
    //           label: (<Link to={route.path}>{L(route.title)}</Link>),
    //           key: route.path,
    //           icon: route.icon && (<AbbIcon name={route.icon} />),
    //           }
    //         );
    //       }
    //       //有子菜单
    //       else {
    //         if (this.hasAnyMenuNodes(route.children)) {
    //           return (
    //             {
    //               label: (<span>{L(route.title)}</span>),
    //               key: route.path,
    //               icon: (<AbbIcon name={route.icon} />),
    //               children: this.getMenuNodes(route.children),
    //             }
    //           );
    //         } else {
    //           return null;
    //         }
    //       }
    //     })
    // );

    if(abp.utils.getCookieValue('Abp.Login.UserType') == "MSP") {
      return (
        appRouters
          //非布局且显示菜单
          .filter((item) => !item.isLayout && item.showInMenu && !item.path.startsWith("/IworldDetial"))
          .map((route) => {
            //无权限返回null
            if (route.permission && !isGranted(route.permission)) return null;
            //无子菜单
            if (!route.children) {
              return (
                {
                  label: (<Link to={route.path}>{L(route.title)}</Link>),
                  key: route.path,
                  icon: route.icon && (<AbbIcon name={route.icon} />),
                }
              );
            }
            //有子菜单
            else {
              if (this.hasAnyMenuNodes(route.children)) {
                return (
                  {
                    label: (<span>{L(route.title)}</span>),
                    key: route.path,
                    icon: (<AbbIcon name={route.icon} />),
                    children: this.getMenuNodes(route.children),
                  }
                );
              } else {
                return null;
              }
            }
          })
      );
    } else {
      return (
        appRouters
          //非布局且显示菜单
          .filter((item) => !item.isLayout && item.showInMenu && (item.path.startsWith("/IworldDetial")
            || item.path.startsWith("/IWorldDashboard") || item.path.startsWith("/dashboard")))
          .map((route) => {
            //无权限返回null
            if (route.permission && !isGranted(route.permission)) return null;
            //无子菜单
            if (!route.children) {
              return (
                {
                  label: (<Link to={route.path}>{L(route.title)}</Link>),
                  key: route.path,
                  icon: route.icon && (<AbbIcon style={{fontSize: "16px", color: "#696969"}} name={route.icon} />),
                }
              );
            }
            //有子菜单
            else {
              if (this.hasAnyMenuNodes(route.children)) {
                return (
                  {
                    label: (<span>{L(route.title)}</span>),
                    key: route.path,
                    icon: (<AbbIcon style={{fontSize: "16px", color: "#696969"}} name={route.icon} />),
                    children: this.getMenuNodes(route.children),
                  }
                );
              } else {
                return null;
              }
            }
          })
      );
    }
  };

  render() {
    const selectedKey = this.getSelectedMenuKey();
    return (
      <Menu
        mode="horizontal"
        selectedKeys={[selectedKey]}
        items={this.getMenuNodes(appRouters)}
        style={{ width: '100%', height: '100%' }}>
      </Menu>
    );
  }
}
export default withRouter(SiderMenu);
